import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/jh-ui';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export type ApproveOrRejectConfirmationData = { comments: string };

export enum Decision {
    Approve = 'approve',
    Reject = 'reject',
}

const tagName = 'tm-bo-approve-or-reject-confirmation';
@customElement(tagName)
export class ApproveOrRejectConfirmation extends TmBaseComponent {
    @property({ type: String })
    public decision: Decision = Decision.Approve;

    public static get approvalTitle() {
        return 'Approve Company User';
    }

    public static get rejectionTitle() {
        return 'Reject Company User';
    }

    public render() {
        return html`<div>
            <div>
                Are you sure you would like to
                ${this.decision === Decision.Approve ? 'approve' : 'reject'} this companyuser?
            </div>
            <tm-input
                data-testid="comment-input"
                @input=${(e: InputEvent) => this.handleCommentChange(e)}
                no-resize
                class="mt-5"
                type="textarea"
                rows="12"
                label="Comments:"
            ></tm-input>
        </div>`;
    }

    private async handleCommentChange(e: InputEvent) {
        this.dispatchEvent(
            new CustomEvent('comment-change', { detail: (e.target as HTMLInputElement).value })
        );
    }

    public static get styles() {
        return css`
            :host {
                --jh-size-1200: 12rem;
            }
        `;
    }
}
